import { render, staticRenderFns } from "./manageIndustry.vue?vue&type=template&id=0588bcd8&scoped=true&"
import script from "./manageIndustry.vue?vue&type=script&lang=js&"
export * from "./manageIndustry.vue?vue&type=script&lang=js&"
import style0 from "./manageIndustry.vue?vue&type=style&index=0&id=0588bcd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588bcd8",
  null
  
)

export default component.exports